export const REALTIME_DETECTION_LIST = 'REALTIME_DETECTION_LIST';
export const REALTIME_DETECTION_LIST_SUCCESS = 'REALTIME_DETECTION_LIST_SUCCESS';
export const REALTIME_DETECTION_LIST_ERROR = 'REALTIME_DETECTION_LIST_ERROR';

export const UPDATE_REALTIME_DETECTION_LIST = 'UPDATE_REALTIME_DETECTION_LIST';
export const UPDATE_REALTIME_DETECTION_LIST_SUCCESS = 'UPDATE_REALTIME_DETECTION_LIST_SUCCESS';
export const UPDATE_REALTIME_DETECTION_LIST_ERROR = 'UPDATE_REALTIME_DETECTION_LIST_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

export const REALTIME_DETECTION_DATA = 'REALTIME_DETECTION_DATA';
export const REALTIME_DETECTION_DATA_SUCCESS = 'REALTIME_DETECTION_DATA_SUCCESS';
export const REALTIME_DETECTION_DATA_ERROR = 'REALTIME_DETECTION_DATA_ERROR';

export const REALTIME_DETECTON_ALARM_DATA = 'REALTIME_DETECTON_ALARM_DATA';
export const REALTIME_DETECTON_ALARM_SUCCESS = 'REALTIME_DETECTON_ALARM_SUCCESS';
export const REALTIME_DETECTON_ALARM_ERROR = 'REALTIME_DETECTON_ALARM_ERROR';

export const MULTIPLEMODEL_LIST = 'MULTIPLEMODEL_LIST';
export const MULTIPLEMODEL_LIST_SUCCESS = 'MULTIPLEMODEL_LIST_SUCCESS';
export const MULTIPLEMODEL_LIST_ERROR = 'MULTIPLEMODEL_LIST_ERROR';

export const DETECTION_ALGORITHM_LIST = 'DETECTION_ALGORITHM_LIST';
export const DETECTION_ALGORITHM_LIST_SUCCESS = 'DETECTION_ALGORITHM_LIST_SUCCESS';
export const DETECTION_ALGORITHM_LIST_ERROR = 'DETECTION_ALGORITHM_LIST_ERROR';


export const COORDINATE_LIST = 'COORDINATE_LIST';
export const COORDINATE_LIST_SUCCESS = 'COORDINATE_LIST_SUCCESS';
export const COORDINATE_LIST_ERROR = 'COORDINATE_LIST_ERROR';

export const COORDINATE_DETAILS = 'COORDINATE_DETAILS';
export const COORDINATE_DETAILS_SUCCESS = 'COORDINATE_DETAILS_SUCCESS';
export const COORDINATE_DETAILS_ERROR = 'COORDINATE_DETAILS_ERROR';

export const ADD_COORDINATE_DETAILS = 'ADD_COORDINATE_DETAILS';
export const ADD_COORDINATE_DETAILS_SUCCESS = 'ADD_COORDINATE_DETAILS_SUCCESS';
export const ADD_COORDINATE_DETAILS_ERROR = 'ADD_COORDINATE_DETAILS_ERROR';

export const UPDATE_COORDINATE = 'UPDATE_COORDINATE';
export const UPDATE_COORDINATE_SUCCESS = 'UPDATE_COORDINATE_SUCCESS';
export const UPDATE_COORDINATE_ERROR = 'UPDATE_COORDINATE_ERROR';

export const DELETE_COORDINATE = 'DELETE_COORDINATE';
export const DELETE_COORDINATE_SUCCESS = 'DELETE_COORDINATE_SUCCESS';
export const DELETE_COORDINATE_ERROR = 'DELETE_COORDINATE_ERROR';

export const UPDATE_REALTIME_DETECTION_LIST_DETAILS = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS';
export const UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS';
export const UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR';

export const ASN_DATA_LIST = 'ASN_DATA_LIST';
export const ASN_DATA_LIST_SUCCESS = 'ASN_DATA_LIST_SUCCESS';
export const ASN_DATA_LIST_ERROR = 'ASN_DATA_LIST_ERROR';

export const MODAL_DATA_LIST = 'MODAL_DATA_LIST';
export const MODAL_DATA_LIST_SUCCESS = 'MODAL_DATA_LIST_SUCCESS';
export const MODAL_DATA_LIST_ERROR = 'MODAL_DATA_LIST_ERROR';

export const AIS_NAME_FILTER = 'AIS_NAME_FILTER';
export const AIS_NAME_FILTER_SUCCESS = 'AIS_NAME_FILTER_SUCCESS';
export const AIS_NAME_FILTER_ERROR = 'AIS_NAME_FILTER_ERROR';

export const SPECTROGRAM_LIST = 'SPECTROGRAM_LIST';
export const SPECTROGRAM_LIST_SUCCESS = 'SPECTROGRAM_LIST_SUCCESS';
export const SPECTROGRAM_LIST_ERROR = 'SPECTROGRAM_LIST_ERROR';

